import { BaseFrameworkError } from "@bloglovin/vue-framework";

class StoryError extends BaseFrameworkError {}

export default StoryError;
